export const KeyboardArrowUp = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
      <path
        d="M5.29289 0.307106C5.68342 -0.083418 6.31658 -0.0834179 6.70711 0.307107L11.3 4.9C11.6866 5.2866 11.6866 5.9134 11.3 6.3C10.9134 6.6866 10.2866 6.6866 9.9 6.3L6.70711 3.10711C6.31658 2.71658 5.68342 2.71658 5.29289 3.10711L2.1 6.3C1.7134 6.6866 1.0866 6.6866 0.7 6.3C0.3134 5.9134 0.3134 5.2866 0.7 4.9L5.29289 0.307106Z"
        fill="currentColor"
      />
    </svg>
  )
}
